export default "__VITE_PUBLIC_ASSET__08fdee92__"